<template>
  <div class="info-box">
    <!-- Header -->
    <div class="info-box-header">
      <p class="customer-benefit" wovn-ignore>{{ customer.name }}</p>
      <span class="customer-name">様</span>
    </div>

    <!-- Detail -->
    <div class="info-box-content">
      <div class="customer-address">
        <div class="row-info">
          <span class="col-name">住所</span>
          <div>
            <p class="col-value" v-if="customer.address && customer.address.zipcode" wovn-ignore>〒 {{ customer.address.zipcode }}</p>
            <p class="col-value" wovn-ignore>
              {{ customer.address.location }}
            </p>
          </div>
        </div>
      </div>
      <div class="customer-job">
        <div class="company">
          <div class="row-info">
            <span class="col-name">会社名</span>
            <span class="col-value" wovn-ignore>{{ customer.companyName }}</span>
          </div>
        </div>
        <div class="division">
          <div class="row-info">
            <span class="col-name">部署名</span>
            <span class="col-value" wovn-ignore>{{ customer.divisionName }}</span>
          </div>
        </div>
      </div>
      <div class="customer-contact">
        <div class="email">
          <div class="row-info">
            <span class="col-name">ご連絡先メールアドレス</span>
            <span class="col-value one-lines-ellipsis" wovn-ignore>{{
              customer.emailAddress
            }}</span>
          </div>
        </div>
        <div class="phone-1">
          <div class="row-info">
            <span class="col-name">ご連絡先電話番号</span>
            <span class="col-value ml-3" wovn-ignore>{{ customer.phoneNumber1 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { GET_PROFILE } from '@/store/modules/bs_app/actions'

export default {

  name: 'CustomerInfo',
  props: ['profileInfo'], 
  data() {
    return {
      companyName: '',
      customer: {
        firstName: '',
        familyName: '',
        name: '',
        profileInfo: '',
        address: {
          social: '会社',
          zipcode: '',
          location: ''
        },
        companyName: '',
        divisionName: '',
        emailAddress: '',
        phoneNumber1: '',
        phoneNumber2: '',
        zipCode1: '',
        zipCode2: '',
        address1: '',
        address2: ''
      }
    }
  },
  computed: {
    getInfoDetail() {
      return _.cloneDeep(
        _.get(this.$store.state, 'bs_app.bs_app.info_detail', null)
      )
    }
  },
  watch: {
    customer: {
      deep: true,
      handler(val) {
        this.$emit('onChange', val)
      }
    },
    profileInfo: {
      deep: true,
      handler() {
        this.bindData()
      }
    }
  },
  mounted() {
    this.getProfileInfo()
  },
  methods: {
    bindData() {
      const customerInfo = this.getInfoDetail ? this.getInfoDetail : null
      if (customerInfo !== null) {
        if (
          customerInfo.firstName === null &&
          customerInfo.familyName === null
        ) {
          this.customer.name = 'ベネフィット太郎'
        } else {
          this.customer.name = `${_.get(customerInfo, 'familyName', '')} ${_.get(
            customerInfo,
            'firstName',
            ''
          )}`
        }
        this.customer.address.zipcode = `${_.get(
          customerInfo,
          'zipCode1',
          ''
        )}-${_.get(customerInfo, 'zipCode2', '')}`
        this.customer.address.location = 
          _.get(customerInfo, 'prefectures', '') +
          _.get(customerInfo, 'cityAddress', '') +
          _.get(customerInfo, 'apartment_number', '')
        this.customer.companyName = this.companyName
        this.customer.divisionName = ''
        this.customer.emailAddress = _.get(customerInfo, 'email', '')
        this.customer.phoneNumber1 = _.get(customerInfo, 'tel', '')
        // this.customer.phoneNumber2 = _.get(customerInfo, 'tel', '')
        this.customer.phoneNumber2 = ''
      } else {
        const profileInfo = this.profileInfo
        this.customer.name = `${_.get(profileInfo, 'familyName', '')} ${_.get(profileInfo, 'firstName', '')}`
        this.customer.address.location = _.get(profileInfo, 'addresses[0].address1', '')
        const zipCode = _.get(profileInfo, 'addresses[0].postalCode', '').toString()
        if (zipCode !== '') {
          this.zipCode1 = _.get(profileInfo, 'addresses[0].postalCode', '').toString().substring(0, 3)
          this.zipCode2 = _.get(profileInfo, 'addresses[0].postalCode', '').toString().substring(3, 7)
          this.customer.address.zipcode = `${this.zipCode1}-${this.zipCode2}`
        }
        this.customer.companyName = this.companyName
        this.customer.divisionName = ''
        this.customer.emailAddress = _.get(profileInfo, 'email', '')
        this.customer.phoneNumber1 = _.get(profileInfo, 'tel', '')
        this.customer.firstName = _.get(profileInfo, 'firstName', '')
        this.customer.familyName = _.get(profileInfo, 'familyName', '')
        this.customer.zipCode1 = this.zipCode1
        this.customer.zipCode2 = this.zipCode2
        this.customer.address1 = _.get(profileInfo, 'addresses[0].address1', '')
        this.customer.address2 = _.get(profileInfo, 'addresses[0].address2', '')
        // this.customer.phoneNumber2 = _.get(customerInfo, 'tel', '')
      }
    },
    getProfileInfo() {
      this.$store.dispatch(GET_PROFILE).then(
        (data) => {
          if (data) {
            this.companyName = _.get(data, 'companyName', '')
          }
          this.bindData()
        },
        (err) => {
          const error = err.error
          this.$toasted.error(error && error.message ? error.message : error)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
